<div *ngIf="pass && passType === 'active'" class="student-pass-info">
	<div class="room-tag" [style.background]="pass.color_profile.solid_color" #mainBody>
		<sp-room-icon
			[style.display]="'flex'"
			[iconPath]="pass.icon"
			[height]="'14px'"
			[width]="'14px'"
			[iconColor]="'#FFF'"
			[altText]="pass.destination.title">
		</sp-room-icon>

		<div class="pass-card-header-text">
			{{ pass.destination.title }}
		</div>
	</div>

	<div class="pass-time-range">{{ pass.start_time | date : 'h:mm a' }} - {{ pass.expiration_time | date : 'h:mm a' }}</div>
</div>

<div
	*ngIf="pass && passType === 'wait_in_line'"
	class="student-pass-info"
	customToolTip
	[additionalOffsetY]="-40"
	[position]="'top'"
	[contentTemplate]="pass.isReadyToStart() ? passAttemptTooltip : null">
	<div
		class="room-tag"
		#mainBody
		[style.background]="pass.color_profile.solid_color"
		[style.padding]="pass.isReadyToStart() ? '8px' : ''"
		[style.border-radius]="pass.isReadyToStart() ? '8px' : ''">
		<!--
      Chip text rules:
      - If the waiting in line pass is a destination pass, then we show the position in the destination line
      and the destination eg. "1st in Line to Nurse" (Nurse would be the destination that's limited)

      - If the waiting in line pass is an origin-only-limited pass, then we show only the destination and no
      line position. eg. "Library" (In this case, a wilp would be coming from some limited origin going to
      Library that's not limited

      - If the waiting in line pass is a doubly-linked pass, then we show the position in the destination line
      and the destination. eg. "2nd in Line to Nurse" (In this case, the doubly-linked pass is 2nd in line at
      the limited-destination Nurse)
    -->

		<ng-container *ngIf="pass">
			<span *ngIf="pass.isReadyToStart(); else notReadyTmpl">Start Pass to</span>
			<ng-template #notReadyTmpl>
				<span *ngIf="!pass.is_origin_line">{{ pass.line_position | position }} in Line to </span>
				<span *ngIf="pass.is_origin_line && !!pass.linked_pass">{{ pass.linked_pass.line_position | position }} in Line to </span>
			</ng-template>
		</ng-container>

		<sp-room-icon
			[style.display]="'flex'"
			[iconPath]="pass.icon"
			[height]="'14px'"
			[width]="'14px'"
			[iconColor]="'#FFF'"
			[altText]="pass.destination.title">
		</sp-room-icon>

		<div class="pass-card-header-text">
			{{ pass.destination.title }}
		</div>

		<div *ngIf="pass.isReadyToStart()" class="spinner-timer">
			<sp-timer-spinner [maxSeconds]="30" [startAt]="remainingAttemptSeconds" [showNumber]="false" [size]="15" (pulse)="readyToStartTick($event)">
			</sp-timer-spinner>
		</div>
	</div>
</div>
<ng-template #passAttemptTooltip>
	<div class="ds-tooltip" style="width: 181px">
		<span
			>{{ acceptingPassTimeRemaining }}s left to start your pass or it will be
			{{ pass.missed_start_attempts === 0 ? 'sent back in line' : 'deleted' }}.</span
		>
	</div>
</ng-template>
